import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../components/presentation/Text'
import { getQueryParam } from '../../../utils/helpers/url'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const { t } = useTranslation(['listPlaceNonCompliance'])
  const origin = getQueryParam('origin') || 'serviceOrder'

  return (
    <>
      <Separator weight={10} />
      <FlexGrid justify="space-between" gutter={0.4}>
        <FlexCol>
          <Title size="h2" color={COLORS.dark3} noWrap>
            {t('title', { context: origin })}
          </Title>
        </FlexCol>
      </FlexGrid>
      <Separator weight={2} />
    </>
  )
}

export default PageHeader
